import React from 'react';
import {makeStyles} from "@material-ui/styles";
import {RTL,AlertDialog} from "../../../../components";
import {FormControl, FormHelperText, InputLabel, MenuItem, Select, Typography} from "@material-ui/core";


const useStyles = makeStyles(theme => ({
    dialogTitle:{
        '& > h2':{
            fontWeight:'bold'
        }
    },
    formControl:{
        marginTop:theme.spacing(4)
    }
}));
const PayTutionDialog= props=> {
    const classes=useStyles();
    const {open,onClose,onAccept}=props;
    return (
        <RTL>
            <AlertDialog
                fullWidth={true}
                onClose={onClose}
                onAccept={onAccept}
                maxWidth={'sm'}
                title="پرداخت شهریه (امیرجواد افروغ)" open={open}>
                <Typography variant="body1">
                    برای پرداخت شهریه ی کاربر مد نظر لطفا یکی از پکیج های شهریه ای را وارد نمایید
                </Typography>
                <FormControl className={classes.formControl}>
                    <InputLabel shrink id="demo-simple-select-placeholder-label-label">
                        پکیج شهریه
                    </InputLabel>
                    <Select
                        labelId="demo-simple-select-placeholder-label-label"
                        id="demo-simple-select-placeholder-label"
                        // value={age}
                        // onChange={handleChange}
                        displayEmpty
                        className={classes.selectEmpty}
                    >
                        <MenuItem value={10}>یک ماهه</MenuItem>
                        <MenuItem value={20}>شش ماهه</MenuItem>
                        <MenuItem value={30}>دوازده ماهه</MenuItem>
                    </Select>
                    <FormHelperText>یکی از پکیج های شهریه ای را انتخاب کنید</FormHelperText>
                </FormControl>
            </AlertDialog>
        </RTL>
    );
};

export default PayTutionDialog;